import { FC, PropsWithChildren } from 'react'
import classNames from 'classnames'

type Props = {
  type: 'pink' | 'orange'
  className?: string
}

export const BoxWithBorderNeon: FC<Props & PropsWithChildren> = ({
  type,
  className,
  children,
}) => {
  return (
    <div className={`relative w-full min-h-[354px] flex flex-col ${className}`}>
      <div
        className={classNames({
          'absolute w-full h-full top-0 left-0 rounded-[14px] border-[2.21px] border-solid z-0 mix-blend-hard-light':
            true,
          'border-[#A50035] shadow-pinkneonInset': type === 'pink',
          'border-[#FFAB2D] shadow-orangeInset': type === 'orange',
        })}
      />
      <div
        className={classNames({
          'absolute w-full h-full top-0 left-0 rounded-[14px] border-[2.89px] border-solid z-[1] mix-blend-hard-light':
            true,
          'border-[#FFB3F4] shadow-pinkneonInset': type === 'pink',
          'border-[#FFAB2D] shadow-orangeInset': type === 'orange',
        })}
      />
      <div
        className={classNames({
          'absolute w-full h-full top-0 left-0 rounded-[14px] border-[2.21px] border-solid z-[2] mix-blend-hard-light':
            true,
          'border-white shadow-pinkneon': type === 'pink',
          'border-[rgba(255,201,64,0.2)] shadow-orange': type === 'orange',
        })}
      />
      <div
        className={classNames({
          'absolute w-full h-full top-0 left-0 rounded-[14px] border-[1.36px] border-solid z-[1] mix-blend-hard-light':
            true,
          'border-[#FFDEDE] shadow-pinkneon': type === 'pink',
          'border-[#FFD56A] shadow-orange': type === 'orange',
        })}
      />
      <div
        className={classNames({
          'absolute w-full h-full top-0 left-0 rounded-[14px] border-[0.68px] border-solid z-[1] mix-blend-hard-light':
            true,
          'border-white shadow-pinkNeonCombo': type === 'pink',
          'border-white shadow-orangeInset': type === 'orange',
        })}
      />
      {children}
    </div>
  )
}
